/** CoStar.Api.ListingUser.ViewModels.Enums.Application */
export var Application;
(function (Application) {
    Application[Application["None"] = 0] = "None";
    Application[Application["LoopNetWebsite"] = 1] = "LoopNetWebsite";
    Application[Application["LoopNetAndroidMobileApp"] = 2] = "LoopNetAndroidMobileApp";
    Application[Application["LoopNetAndroidTabletApp"] = 3] = "LoopNetAndroidTabletApp";
    Application[Application["LoopNetiOSMobileApp"] = 4] = "LoopNetiOSMobileApp";
    Application[Application["LoopNetiOSTabletApp"] = 5] = "LoopNetiOSTabletApp";
    Application[Application["CoStarSuiteWebsite"] = 6] = "CoStarSuiteWebsite";
    Application[Application["CoStarSuiteAndroidMobileApp"] = 7] = "CoStarSuiteAndroidMobileApp";
    Application[Application["CoStarSuiteAndroidTabletApp"] = 8] = "CoStarSuiteAndroidTabletApp";
    Application[Application["CoStarSuiteiOSMobileApp"] = 9] = "CoStarSuiteiOSMobileApp";
    Application[Application["CoStarSuiteiOSTabletApp"] = 10] = "CoStarSuiteiOSTabletApp";
    Application[Application["MarketingCenterWebsite"] = 11] = "MarketingCenterWebsite";
    Application[Application["MarketingCenterAndroidMobileApp"] = 12] = "MarketingCenterAndroidMobileApp";
    Application[Application["MarketingCenterAndroidTabletApp"] = 13] = "MarketingCenterAndroidTabletApp";
    Application[Application["MarketingCenteriOSMobileApp"] = 14] = "MarketingCenteriOSMobileApp";
    Application[Application["MarketingCenteriOSTabletApp"] = 15] = "MarketingCenteriOSTabletApp";
    Application[Application["TenXWebsite"] = 16] = "TenXWebsite";
    Application[Application["TenXAndroidMobileApp"] = 17] = "TenXAndroidMobileApp";
    Application[Application["TenXAndroidTabletApp"] = 18] = "TenXAndroidTabletApp";
    Application[Application["TenXiOSMobileApp"] = 19] = "TenXiOSMobileApp";
    Application[Application["TenXiOSTabletApp"] = 20] = "TenXiOSTabletApp";
})(Application || (Application = {}));
